import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

function tratamentoResponse(response, chamada) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = function (data, aplicativoDados) {
    try {
        console.log("ErroRequisicao> ", data.request, data.message)
        if (data.message == "Network Error") {
            return "Verifique sua conexão!"
        } else if (data.message) {
            return "Erro: " + data.message
        }
        return false
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
    }
}

//Cadastrar
export const cadastrarCategoria = async (idCardapio, data, autorizacao) => {
    const url = `cardapio/categoria/cadastro/${idCardapio}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("cadastrarCategoria  => ", response)

        return tratamentoResponse(response, "cadastrarCategoria")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarCategoria", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const cadastrarProduto = async (idCategoria, data, autorizacao) => {
    const url = `cardapio/produto/cadastro/${idCategoria}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api.post(url, data, { headers: headers }).catch(function (error) {
            const resp = ErroRequisicao(error)
            return { data: { codErro: 1, mensagem: resp } }
        })
        console.log("cadastrarProduto  => ", response)

        return tratamentoResponse(response, "cadastrarProduto")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarProduto", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const cadastrarGrupoDeOpcao = async (idProduto, data, autorizacao) => {
    const url = `cardapio/grupoopcao/cadastro/${idProduto}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        console.log("cadastrarGrupoDeOpcao  => ", response)

        return tratamentoResponse(response, "cadastrarGrupoDeOpcao")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarGrupoDeOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const cadastrarOpcao = async (idGrupoOpcao, data, autorizacao) => {
    const url = `cardapio/opcao/cadastro/${idGrupoOpcao}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        console.log("cadastrarOpcao  => ", response)

        return tratamentoResponse(response, "cadastrarOpcao")
    } catch (error) {
        RegistrarLogErro(error, "cadastrarOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

//Duplicar
export const duplicarCategoria = async (data, autorizacao) => {
    const url = "cardapio/categoria/duplicar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("duplicarCategoria  => ", response)

        return tratamentoResponse(response, "duplicarCategoria")
    } catch (error) {
        RegistrarLogErro(error, "duplicarCategoria", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const duplicarProduto = async (data, autorizacao) => {
    const url = "cardapio/produto/duplicar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("duplicarProduto  => ", response)

        return tratamentoResponse(response, "duplicarProduto")
    } catch (error) {
        RegistrarLogErro(error, "duplicarProduto", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const duplicarGrupoDeOpcao = async (data, idProduto, autorizacao) => {
    const url = `cardapio/grupoopcao/duplicar/${idProduto}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("duplicarGrupoDeOpcao  => ", response)

        return tratamentoResponse(response, "duplicarGrupoDeOpcao")
    } catch (error) {
        RegistrarLogErro(error, "duplicarGrupoDeOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Excluir
export const excluirCategoria = async (data, autorizacao) => {
    const url = "cardapio/categoria/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("excluirCategoria  => ", response)

        return tratamentoResponse(response, "excluirCategoria")
    } catch (error) {
        RegistrarLogErro(error, "excluirCategoria", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const excluirProduto = async (data, autorizacao) => {
    const url = "cardapio/produto/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("excluirProduto  => ", response)

        return tratamentoResponse(response, "excluirProduto")
    } catch (error) {
        RegistrarLogErro(error, "excluirProduto", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const excluirGrupoDeOpcao = async (data, autorizacao) => {
    const url = "cardapio/grupoopcao/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("excluirGrupoDeOpcao  => ", response)

        return tratamentoResponse(response, "excluirGrupoDeOpcao")
    } catch (error) {
        RegistrarLogErro(error, "excluirGrupoDeOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const excluirOpcao = async (data, autorizacao) => {
    const url = "cardapio/opcao/excluir"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("excluirOpcao  => ", response)

        return tratamentoResponse(response, "excluirOpcao")
    } catch (error) {
        RegistrarLogErro(error, "excluirOpcao", data)
        return { retornoErro: 1, mensagem: error.message }
    }
}

// Inativar

export const inativarProduto = async (idProduto, boolean, autorizacao) => {
    const url = `cardapio/produto/ativardesativar/${idProduto}/${!boolean}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("inativarProduto  => ", response)

        return tratamentoResponse(response, "inativarProduto")
    } catch (error) {
        RegistrarLogErro(error, "inativarProduto")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const inativarOpcao = async (idOpcao, boolean, autorizacao) => {
    const url = `cardapio/opcao/ativardesativar/${idOpcao}/${!boolean}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("inativarOpcao  => ", response)

        return tratamentoResponse(response, "inativarOpcao")
    } catch (error) {
        RegistrarLogErro(error, "inativarOpcao")
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const ativarInativarMassa = async (idEstabelecimento, data, autorizacao) => {
    const url = `cardapiosimplificado/ativardesativar/lista/${idEstabelecimento}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api
            .post(url, data, {
                headers: headers,
            })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })

        console.log("inativarMassa   => ", response)

        return tratamentoResponse(response, "inativarMassa ")
    } catch (error) {
        RegistrarLogErro(error, "inativarMassa ")
        return { retornoErro: 1, mensagem: error.message }
    }
}

//obter cardapio

export const obterCardapioParaEdicaoEmMassa = async (idEstabelecimento, autorizacao) => {
    const url = `cardapiosimplificado/${idEstabelecimento}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api.get(url, {
            headers: headers,
        })

        console.warn("obterCardapioParaEdicaoEmMassa =>", response)

        return tratamentoResponse(response, "obterCardapioParaEdicaoEmMassa")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "obterCardapioParaEdicaoEmMassa", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

//Salvar Cardapio completo

export const salvarCardapioCompleto = async (idEstabelecimento, data, autorizacao) => {
    const url = `cardapio/salvar/${idEstabelecimento}`
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }

    try {
        const response = await api.post(url, data, {
            headers: headers,
        })

        console.warn("salvarCardapioCompleto =>", response)

        return tratamentoResponse(response, "salvarCardapioCompleto")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "salvarCardapioCompleto", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

//Cadastrar Imagem

export const cadastrarImagem = async (
    idEstabelecimento,
    nomeArquivo,
    idProduto,
    idOpcao,
    file,
    autorizacao
) => {
    const url =
        `cardapio/photo/${idEstabelecimento}/${nomeArquivo}` +
        (idOpcao ? `?idOpcao=${idOpcao}` : idProduto ? `?idProduto=${idProduto}` : "")
    const headers = { "Content-Type": "application/octet-stream", Authorization: autorizacao }

    try {
        const response = await api.put(url, file, {
            headers: headers,
        })

        console.warn("cadastrarImagem =>", response)

        return tratamentoResponse(response, "cadastrarImagem")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "cadastrarImagem", {})
        return { retornoErro: 1, mensagem: error.message }
    }
}

export const obterCardapioRegistrador = async (idEstabelecimento, Authorization) => {
    try {
        const response = await api.get("cardapio/pedido/" + idEstabelecimento, {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
            },
        })

        console.warn("obterCardapioRegistrador =>", response)

        return tratamentoResponse(response, "obterCardapioRegistrador")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "obterCardapioRegistrador")
    }
}

export const salvarEdicaoEmMassa = async (idEstabelecimento, data, Authorization) => {
    try {
        const response = await api.post(`cardapio/update/lista/${idEstabelecimento}`, data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: Authorization,
            },
        })

        console.warn("salvarEdicaoEmMassa =>", response)

        return tratamentoResponse(response, "salvarEdicaoEmMassa")
    } catch (error) {
        console.error(error)
        RegistrarLogErro(error, "salvarEdicaoEmMassa", {})
        return { retornoErro: 1, mensagem: error.mensagem }
    }
}

export const interpretarCardapioIA = async (texto, autorizacao) => {
    const url = "cardapio-ia/interpretar"
    const headers = { "Content-Type": "application/json", Authorization: autorizacao }
    try {
        const response = await api
            .post(url, { texto }, { headers })
            .catch(function (error) {
                const resp = ErroRequisicao(error)
                return { data: { codErro: 1, mensagem: resp } }
            })
        return tratamentoResponse(response, "interpretarCardapioIA")
    } catch (error) {
        RegistrarLogErro(error, "interpretarCardapioIA", { texto })
        return { retornoErro: 1, mensagem: error.message }
    }
}

// export const ObterImagens = async (idEstabelecimento, Authorization) => {
//     try {
//         const response = await api.get("cardapio/photos/" + idEstabelecimento, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Authorization: Authorization,
//             },
//         })

//         console.warn("ObterImagens =>", response)

//         return tratamentoResponse(response, "ObterImagens")
//     } catch (error) {
//         console.error(error)
//         RegistrarLogErro(error, "ObterImagens", {})
//     }
// }
